import { IDateRange } from '../../types/dateRange';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const CHANGE_DEPARTURE_DATES = 'filters/change_departure_dates' as const;

export const changeDepartureDates = actionGenerator<typeof CHANGE_DEPARTURE_DATES, IDateRange>(CHANGE_DEPARTURE_DATES);

export type TChangeDepartureDates = ReturnType<typeof changeDepartureDates>;
